import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { SharedProgrammingService } from '../services/shared-programming.service';
import { ScheduleProgrammingService } from './../../quickstarts/quickstart-schedule/services/schedule.service';
import { ProgrammingEventsState } from '../services/events.service';

@Component({
  selector: 'prg-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.less']
})
export class SummaryComponent implements OnInit {

  private events: Observable<Array<any>>;
  private scheduleEvents: Observable<Array<any>>;
  private ready: Observable<boolean>;
  private initialized: Observable<boolean>;

  constructor(
    private store: Store<{ programmingEvents: ProgrammingEventsState }>,
    private shared: SharedProgrammingService,
    private schedule: ScheduleProgrammingService
  ) {
    this.events = this.store.select(s => s.programmingEvents.programmedEvents);
  }

  ngOnInit() {
    this.shared.clearError();
  }

  private refresh() {
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/summary/summary.component.ts